import { Observable } from "rxjs";
import { combineEpics } from "redux-observable";

import st from "lib/utils/index";
import { OrdersRepository } from "lib/repositories/index";
import { replaceCompanyRoute } from "modules/app/actions";
import { createResourceInstance } from "modules/utils/index";
import createOrdersFiltersInstance from "./createOrdersFiltersInstance";

export const INITIALIZE_VIEW = "orders/OrdersListView/INITIALIZE_VIEW";
export const DESTROY_VIEW = "orders/OrdersListView/DESTROY_VIEW";
export const LOAD_RECORDS = "orders/OrdersListView/LOAD_RECORDS";
export const FETCH_RECORDS = "orders/OrdersListView/FETCH_RECORDS";
export const FETCH_RECORDS_START = "orders/OrdersListView/FETCH_RECORDS_START";
export const FETCH_RECORDS_SUCCESS = "orders/OrdersListView/FETCH_RECORDS_SUCCESS";
export const FETCH_RECORDS_FAILURE = "orders/OrdersListView/FETCH_RECORDS_FAILURE";
export const CHANGE_FILTERS = "orders/OrdersListView/CHANGE_FILTERS";
export const CHANGE_PAGINATION = "orders/OrdersListView/CHANGE_PAGINATION";
export const SET_FILTERS = "orders/OrdersListView/SET_FILTERS";
export const SET_PAGINATION = "orders/OrdersListView/SET_PAGINATION";

export const stateSelector = (state) => state.orders.OrdersListView;

const ordersInstance = createResourceInstance({
  LOAD: LOAD_RECORDS,
  FETCH: FETCH_RECORDS,
  FETCH_START: FETCH_RECORDS_START,
  FETCH_SUCCESS: FETCH_RECORDS_SUCCESS,
  FETCH_FAILURE: FETCH_RECORDS_FAILURE,
  stateSelector,
  stateKey: "records",
  getModel: ({ offset, limit, filters }) => {
    return OrdersRepository.search({ offset, limit, ...filters });
  },
});

const filtersInstance = createOrdersFiltersInstance({
  SET_FILTERS,
  getInitialFilters: () => ({
    created_on: {
      gte: moment().add(-1, "months").date(1).format(moment.RUBY_DATE_FORMAT),
    },
  }),
});

const limit = parseInt(localStorage.getItem("ordersLimit"), 10) || 10;
const initialState = {
  records: ordersInstance.initialState,
  ...filtersInstance.initialState,
  offset: 0,
  limit: limit,
};

const reducers = {
  ...ordersInstance.reducersMap,
  ...filtersInstance.reducersMap,

  [INITIALIZE_VIEW]: () => initialState,

  [SET_PAGINATION]: (state, { offset = state.offset, limit = state.limit }) => ({
    ...state,
    offset,
    limit,
  }),
};

const viewEpics = [
  ...ordersInstance.epics,
  ...filtersInstance.epics,

  (actions$) => actions$.ofType(CHANGE_FILTERS).map(({ filters }) => setFilters(filters)),

  (actions$) => actions$.ofType(CHANGE_PAGINATION).map(({ offset, limit }) => setPagination({ offset, limit })),

  (actions$) =>
    actions$.ofType(CHANGE_FILTERS).merge(actions$.ofType(CHANGE_PAGINATION)).debounceTime(300).mapTo(fetchRecords()),

  (actions$, { getState }) =>
    actions$
      .ofType(SET_FILTERS)
      .debounceTime(500)
      .map(() => {
        const { filters } = stateSelector(getState());
        const query = filtersInstance._serializeFiltersToLocationQuery(filters);
        return replaceCompanyRoute({ pathname: "/orders", query });
      }),
];

const epics = [
  (actions$, store) =>
    actions$
      .ofType(INITIALIZE_VIEW)
      .concatMap(() => combineEpics(...viewEpics)(actions$, store).takeUntil(actions$.ofType(DESTROY_VIEW))),
];

export const { setFilters, setFiltersWithLocationQuery } = filtersInstance.actions;
export const { load: loadRecords, fetch: fetchRecords } = ordersInstance.actions;

export function initializeView() {
  return { type: INITIALIZE_VIEW };
}

export function destroyView() {
  return { type: DESTROY_VIEW };
}

export function setPagination({ offset, limit }) {
  return { type: SET_PAGINATION, offset, limit };
}

export function changePagination({ offset, limit }) {
  return { type: CHANGE_PAGINATION, offset, limit };
}

export function changeFilters(filters) {
  return { type: CHANGE_FILTERS, filters };
}

export function changeFiltersAndResetOffset(filters) {
  return (dispatch) => {
    dispatch(changePagination({ offset: 0, limit: 10 }));
    dispatch(changeFilters(filters));
  };
}

export function setParamsWithLocationQuery({ o = initialState.offset, l = initialState.limit, ...query } = {}) {
  return (dispatch) => {
    dispatch(setFiltersWithLocationQuery(query));
    dispatch(setPagination({ offset: +o, limit: +l }));
    dispatch(fetchRecords());
  };
}

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/orders/OrdersListView/index.js